var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnIst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25388_346049)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.975 10.85H18.725L20.678 8.897C19.145 6.8915 16.7195 5.6 14 5.6C9.359 5.6 5.6 9.359 5.6 14C5.6 15.9215 6.2405 17.675 7.322 19.0925C8.603 17.6225 11.0075 16.625 14 16.625C16.9925 16.625 19.4075 17.6225 20.678 19.0925C21.7595 17.675 22.4 15.9215 22.4 14H24.5C24.5 19.775 19.775 24.5 14 24.5C8.225 24.5 3.5 19.775 3.5 14C3.5 8.225 8.225 3.5 14 3.5C17.297 3.5 20.2475 5.0225 22.169 7.406L23.975 5.6V10.85ZM14 8.75C15.743 8.75 17.15 10.157 17.15 11.9C17.15 13.643 15.743 15.05 14 15.05C12.257 15.05 10.85 13.643 10.85 11.9C10.85 10.157 12.257 8.75 14 8.75Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25388_346049"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnIst);
export default __webpack_public_path__ + "static/media/icn_ist.f6976b692f6e010295c855c73ce1a30e.svg";
export { ForwardRef as ReactComponent };